import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

export const StoreFrontIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M3 21h18' />
    <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1H3l2-4h14l2 4' />
    <path d='M5 21V10.85' />
    <path d='M19 21V10.85' />
    <path d='M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4' />
  </Icon>
);

export default StoreFrontIcon;
